import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';

import {Grid} from "@material-ui/core";
import withStyles from "@material-ui/core/styles/withStyles";

import { MuiThemeProvider } from '@material-ui/core/styles';
import {createDefaultTheme} from '../../../../themes/themeConfigurator';

import styles from './styles';

import CoverPageDocument from "./components/CoverPageDocument";
import TabsContainer from "../../../../components/TabsContainer";
import PDFSettingsPreview from "./components/PDFSettingsPreview";


const breakpoints = {
  values: {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1492,
    xl: 1920
  }
};
const theme = createDefaultTheme({'breakpoints': breakpoints});


const mapStateToProps = (state) => ({
  customer: state.get('reporting').toJS().customer,
});

const REPORT_PREVIEW_TAB_ID = 'report';
const COVER_PREVIEW_TAB_ID = 'cover';

const TABS = [{
  id: COVER_PREVIEW_TAB_ID,
  label: 'Vorschau Anschreiben'
}, {
  id: REPORT_PREVIEW_TAB_ID,
  label: 'Vorschau Vermögensübersicht'
}];

const CoverPagePreview = ({classes, reportSettings, customer, documentPageSize}) => (
  <Grid container className={classes.gridContainer} spacing={2}>
    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} id="reporting-cover-page-preview-tour-element">
      <div className={classes.itemContainer}>
        <CoverPageDocument reportSettings={reportSettings} customer={customer} pageWidth={documentPageSize}/>
      </div>
    </Grid>
  </Grid>
);

const PreviewTabs = ({classes, coverMsgEnabled, reportSettings, customer, documentPageSize}) => {

  const [currentTab, setCurrentTab] = React.useState(COVER_PREVIEW_TAB_ID);
  // to cache tab we track first mount and then hide (so it's always in the dom)
  const [reportPreviewVisited, setReportPreviewVisited] = React.useState(false);

  const handleCurrentTabChange = (event, tabId) => {
    if(tabId === REPORT_PREVIEW_TAB_ID){
      setReportPreviewVisited(true);
    }
    setCurrentTab(tabId);
  };

  return (
    <TabsContainer
      customClasses={{tab: classes.tab}}
      value={currentTab}
      onChange={handleCurrentTabChange}
      tabs={TABS}
      tabContent={
        <>
          <div hidden={currentTab !== COVER_PREVIEW_TAB_ID}>
            {coverMsgEnabled
              ? <CoverPagePreview classes={classes} reportSettings={reportSettings} customer={customer} documentPageSize={documentPageSize} />
              : <div style={{textAlign: 'center'}}>Keine Vorschau verfügbar – kein Anschreiben ausgewählt.</div>
            }
          </div>
          {reportPreviewVisited && (
            <div hidden={currentTab !== REPORT_PREVIEW_TAB_ID}>
              <PDFSettingsPreview reportSettings={reportSettings} pageWidth={documentPageSize - 48} />
            </div>
          )}
        </>
      }
    />
  )
};

const PreviewStepContent = (props) => {
  const {
    classes,
    reportSettings,
    customer,
    documentPageSize,
    isGroupReporting,
  } = props;

  const [coverMsgEnabled, setCoverMsgEnabled] =  React.useState(false);

  React.useEffect(() => {
    let enabled = false;

    if (!_.isEmpty(reportSettings)) {
      enabled = !!(_.get(reportSettings, 'cover_message_enabled') && _.get(reportSettings, 'cover_message_content'));
    }
    setCoverMsgEnabled(enabled)
  }, [reportSettings]);

  return (
    <MuiThemeProvider theme={theme}>
      <Grid className={classes.container}>
        {isGroupReporting ? (
          <PreviewTabs
            classes={classes}
            coverMsgEnabled={coverMsgEnabled}
            reportSettings={reportSettings}
            customer={customer}
            documentPageSize={documentPageSize}
          />
        ) : coverMsgEnabled && (
          <CoverPagePreview
            classes={classes}
            reportSettings={reportSettings}
            customer={customer}
            documentPageSize={documentPageSize}
          />
        )}
      </Grid>
    </MuiThemeProvider>
  )
};

export default withStyles(styles)(
  connect(mapStateToProps)(PreviewStepContent)
);